<template>
  <div class="review-import">
    <ipub-model :title="'Import Reviewers'"
                width="1150px"
                :visable="isVisable"
                :showFooter="false"
                @confirm="confirm"
                @cancel="cancel">
      <div class="flex-center mar-b-30"
           style="justify-content: space-between;">
        <div v-for="(item,index) in stepList"
             :key="index"
             :class="['step','flex' ,'ipub-p1',step===item.step?'active':'']">
          <div class="step-block" style="z-index:1000">
            <div class="step-bg">
              <ipub-icon :type="item.icon"
                         class=""
                         style="font-size:30px" />
            </div>
            <div class="step-font">{{ item.name }}</div>
          </div>
          <div class="step-line"></div>
        </div>
      </div>
      <div v-if="step==='step1'">
        <div class="prepare ipub-p2 mar-b-20">
          <div class="ipub-p1">Tips</div>
          <div>* No more than 20 reviewers per list.</div>
          <div @click="downloadTemp"
               class="ipub-p2 fw-bd link-color mar-b-30 ipub-c-p">
            <ipub-icon type="iconDownload1"
                       class="ipub-p2" />
            Download the template file
          </div>
        </div>
        <div class="ipub-p2 fw-bd mar-b-30">
          Upload the file with data
          <ipub-upload class="ipub-c-p"
                       @change="handleUpload">
            <a class="link-color mar-l-30">
              <ipub-icon type="iconAdd"
                         class="ipub-p1" />Upload the File
            </a>
          </ipub-upload>
          <div class="ipub-p2 mar-b-10">
            <div>* Supported file format: .xls, .xlsx</div>
            <div>* The file should be less than 2MB.</div>
          </div>

          <div class="ipub-p2"
               v-if="reviewExc && reviewExc.length>0">
            <ipub-label class="ipub-c-p">
              <font class="ipub-p2">{{reviewExc[0].name}}
                <ipub-icon type="iconDownload1"
                           @click="download(reviewExc[0])"
                           class="mar-l-10 padding-right" />
              </font>
              <ipub-icon type="iconDelete"
                         class="mar-l-5"
                         @click="handleDelete" />
            </ipub-label>
          </div>
        </div>
        <ipub-button type="primary"
                     style="min-width:230px"
                     @click="cancel"
                     plain>Cancel</ipub-button>
        <ipub-button type="primary"
                     @click="confirmStep1"
                     style="min-width:230px">Confirm & Next</ipub-button>
      </div>
      <div v-if="step==='step2'">
        <div class="mar-b-20"
             v-if="dataSource && dataSource['importedList'] && dataSource['importedList'].length>0">
          <div class="padding success-bg ipub-p1 line-h-40">
            <font class="success-color">
              <ipub-icon type="iconAble" /> {{dataSource['importedList'].length}}
            </font>
            reviewers will be import.
          </div>
          <ipub-table :columns="columns"
                      border
                      :pagination="false"
                      :dataSource="dataSource['importedList']">
            <template v-slot:hindex="{text,record}">
              <font class="ipub-p2">{{text ? text : '- -'}}</font>
              <ipub-tooltip style="width:100%"
                            class="mar-l-10 ipub-p2">
                <div slot="title">
                  <font v-if="record.hindexUrl">H-Index URL</font>
                  <font v-else>Link to Scopus</font>
                </div>
                <a :href="record.hindexUrl"
                   @click="openLink(record)"
                   target="_blank">
                  <ipub-icon type="iconReference"
                             class="link-color" />
                </a>
              </ipub-tooltip>
            </template>
            <template v-slot:omisst="{text}">
              <ipub-tooltip class="mar-l-10 ipub-p2"
                            style="width:100%"
                            v-if="text">
                <div slot="title">
                  <span>{{text}}</span>
                </div>
                <div class="omission-2">
                  {{text}}
                </div>
              </ipub-tooltip>
              <template v-else>- -</template>

            </template>
          </ipub-table>
        </div>
        <div class="mar-b-20"
             v-if="dataSource && dataSource['replacedList'] && dataSource['replacedList'].length>0">
          <div class="padding warning-bg ipub-p1 line-h-40">
            <font class="warning-color">
              <ipub-icon type="iconDetails" /> {{dataSource['replacedList'].length}}
            </font>
            reviewers’ personal information are already exist, Only H-index and H-index URL will be updated after the import.
          </div>
          <ipub-table :columns="columns"
                      border
                      :pagination="false"
                      :dataSource="dataSource['replacedList']">
            <template v-slot:hindex="{text,record}">
              <font class="ipub-p2">{{text ? text : '- -'}}</font>
              <ipub-tooltip style="width:100%"
                            class="mar-l-10 ipub-p2">
                <div slot="title">
                  <font v-if="record.hindexUrl">H-Index URL</font>
                  <font v-else>Link to Scopus</font>
                </div>
                <a :href="record.hindexUrl"
                   @click="openLink(record)"
                   target="_blank">
                  <ipub-icon type="iconReference"
                             class="link-color" />
                </a>
              </ipub-tooltip>
            </template>
            <template v-slot:omisst="{text}">
              <ipub-tooltip class="mar-l-10 ipub-p2"
                            style="width:100%"
                            v-if="text">
                <div slot="title">
                  <span>{{text}}</span>
                </div>
                <div class="omission-2">
                  {{text}}
                </div>
              </ipub-tooltip>
              <template v-else>- -</template>

            </template>
          </ipub-table>
        </div>
        <div class="mar-b-20"
             v-if="dataSource && dataSource['errorList'] && dataSource['errorList'].length>0">
          <div class="padding key-bg ipub-p1 line-h-40">
            <font class="key-color">
              <ipub-icon type="iconCancel" /> {{dataSource['errorList'].length}}
            </font>
            reviewers‘ information are not correct and will not be imported!
          </div>
          <ipub-table :columns="columnsError"
                      border
                      :pagination="false"
                      :dataSource="dataSource['errorList']">
            <template v-slot:hindex="{text,record}">
              <font class="ipub-p2">{{text ? text : '- -'}}</font>
              <ipub-tooltip style="width:100%"
                            class="mar-l-10 ipub-p2">
                <div slot="title">
                  <font v-if="record.hindexUrl">H-Index URL</font>
                  <font v-else>Link to Scopus</font>
                </div>
                <a :href="record.hindexUrl"
                   @click="openLink(record)"
                   target="_blank">
                  <ipub-icon type="iconReference"
                             class="link-color" />
                </a>
              </ipub-tooltip>
            </template>
            <template v-slot:omisst="{text}">
              <ipub-tooltip class="mar-l-10 ipub-p2"
                            style="width:100%"
                            v-if="text">
                <div slot="title">
                  <span>{{text}}</span>
                </div>
                <div class="omission-2">
                  {{text}}
                </div>
              </ipub-tooltip>
              <template v-else>- -</template>
            </template>
            <template v-slot:error="{text}">
              <ipub-tooltip class="mar-l-10 ipub-p2"
                            style="width:100%"
                            v-if="text">
                <div slot="title">
                  <div v-html="text.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                </div>
                <div class="omission-2"
                     v-html="text.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')">
                </div>
              </ipub-tooltip>
              <template v-else>- -</template>
            </template>
          </ipub-table>
        </div>
        <div class="mar-b-30">
          <ipub-button type="primary"
                       class="mar-b-30"
                       v-if="dataSource && dataSource.errorFilePath"
                       @click="downloadError(dataSource.errorFilePath)"
                       style="min-width:230px">Download Error Report</ipub-button>
        </div>
        <div class="ipub-p2 mar-b-10">Ignore the error data and continue importing the reviewers?</div>
        <ipub-button type="primary"
                     style="min-width:230px"
                     @click="cancel"
                     plain>Cancel</ipub-button>
        <ipub-button type="primary"
                     @click="confirmStep2"
                     :disabled="!dataSource || (dataSource['replacedList'].length==0 && dataSource['importedList'].length==0)"
                     style="min-width:230px">Confirm & Next</ipub-button>
      </div>
      <div style="text-align:center"
           v-if="step==='step3'">
        <div class="ipub-p2 mar-b-20">
          <ipub-icon type="iconAble"
                     style="font-size:65px"
                     class="success-color" />
          <div class="ipub-h1">
            Import Successfully
          </div>
          {{((dataSource && dataSource['replacedList'] && dataSource['replacedList'].length) || 0) + ((dataSource && dataSource['importedList'] && dataSource['importedList'].length) || 0)}} reviewers have been successfully imported.
        </div>
        <ipub-button type="primary"
                     @click="confirm">Back to Manuscript Detail</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { minvitedReviewer } from '@/api/reviewer'
import { statics } from '@/api/statics'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { getUploadConfig } from '@/utils/upload'

const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
  },
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'special',
    slot: 'name',
  },
  {
    title: '',
    enTitle: 'Affiliation(s)',
    width: 120,
    dataIndex: 'affiliation',
    slot: 'omisst'
  },
  {
    title: '',
    enTitle: 'H-index',
    width: 150,
    dataIndex: 'hindex',
    slot: 'hindex'
  },
  {
    title: '',
    enTitle: 'H-index URL',
    width: 150,
    dataIndex: 'hindexUrl',
    slot: 'omisst'
  },
  {
    title: '',
    enTitle: 'Research Keywords',
    width: 150,
    dataIndex: 'keyword',
    slot: 'omisst'
  }
]
const columnsError = [
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'omisst'
  },
  {
    title: '',
    enTitle: 'Name',
    width: 200,
    dataIndex: 'special',
    slot: 'name',
  },
  {
    title: '',
    enTitle: 'Affiliation(s)',
    width: 100,
    dataIndex: 'affiliation',
    slot: 'omisst'
  },
  {
    title: '',
    enTitle: 'H-index',
    width: 150,
    dataIndex: 'hindex',
    slot: 'hindex'
  },
  {
    title: '',
    enTitle: 'H-index URL',
    width: 150,
    dataIndex: 'hindexUrl',
    slot: 'omisst'
  },
  {
    title: '',
    enTitle: 'Research Keywords',
    width: 100,
    dataIndex: 'keyword',
    slot: 'omisst'
  },
  {
    title: '',
    enTitle: 'Errors',
    width: 150,
    dataIndex: 'msg',
    slot: 'error'
  }
]
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      step: 'step1',
      reviewExc: [],
      stepList: [
        { name: 'Prepare Data', icon: 'iconManuscript', step: 'step1' },
        { name: 'Data Check', icon: 'iconAuthor', step: 'step2' },
        { name: 'Import Result', icon: 'icona-UploadDoc', step: 'step3' }
      ],
      dataSource: {},
      columns: columns,
      columnsError: columnsError
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.reviewExc = []
        this.step = 'step1'
      }
    }
  },
  methods: {
    async downloadTemp () {
      const res = await statics.download('Reviewers Import Template.xlsx')
      help.download(res.url, 'Reviewers Import Template.xlsx')
    },
    async handleUpload (files) {
      const file = files[0]
      const types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
      const rightType = types.includes(file.type)
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: 'Please upload the file in the correct format: *.xls, *.xlsx'
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: 'The file should be less than 2M.'
        })
        return false
      }
      this.addFile(file)
    },
    async addFile (file) {
      const path = `publisher/manuscript/reviewer/${help.guid()}`
      this.loading = true
      const url = await getUploadConfig(file, path)
      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }
      const flag = this.reviewExc.some(val => {
        if (file.name === val.name) {
          val = {
            name: file.name,
            size: file.size,
            description: '',
            path: url,
            file: file,
            sort: 0
          }
          return true
        }
      })
      if (!flag) {
        this.reviewExc.push({
          name: file.name,
          size: file.size,
          path: url,
          file: file,
          sort: 0
        })
      }
      this.loading = false
    },
    handleDelete (index) {
      if (index || index === 0) {
        this.reviewExc.splice(index, 1)
      } else {
        this.reviewExc = []
      }
    },
    download (item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    downloadError (path) {
      const url = path
        ? this.domain + '/' + path
        : ''
      help.download(url, 'error_report.xlsx')
    },
    async confirmStep1 () {
      if (!this.reviewExc[0]) {
        return
      }
      let data = {}
      data = new FormData()
      data.append('manuscriptId', this.inputData.id)
      data.append('sign', this.inputData.sign)
      data.append('file', this.reviewExc[0].file)
      const res = await minvitedReviewer.import(data)
      this.dataSource = res
      this.step = 'step2'
      if ((res.errorList && res.errorList.length) + (res.importedList && res.importedList.length) + (res.replacedList && res.replacedList.length) > 20) {
        this.$message.error({
          title: 'Error',
          content: 'The number of reviewers should not be more than 20 at a time.'
        })
        return false
      }
      this.step = 'step2'
    },
    async confirmStep2 () {
      const data = Object.assign(this.dataSource, { manuscriptId: this.inputData.id, sign: this.inputData.sign })
      await minvitedReviewer.importConfirm(data)
      this.step = 'step3'
    },
    confirm () { this.$emit('confirm') },
    cancel () {
      if (this.step === 'step2') {
        this.step = 'step1'
      } else {
        this.$emit('cancel')
      }
    },
    openLink (record) {
      let link = record.hindexUrl ? record.hindexUrl : `https://www.scopus.com/results/authorNamesList.uri?s=AUTHLASTNAME%28${record.lastName}%29+AND+AUTHFIRST%28${record.firstName}%29&st1=${record.lastName}&st2=${record.firstName}`
      help.openWindow(link)
    }
  }
}
</script>
<style lang="scss" scoped>
.step {
  position: relative;
  width: 30%;
  text-align: center;
  justify-content: center;
  cursor: pointer;

  .iconfont {
    font-size: 30px;
    line-height: 70px;
  }
  &-block{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &-bg {
    width: 70px;
    height: 70px;
    background: #e9eef0;
    border-radius: 50%;
    text-align: center;
    z-index: 20;
    margin-bottom: 10px;
  }

  &-line {
    height: 8px;
    background: #e9eef0;
    right: 0;
    top: 35px;
    position: absolute;
    width: 100%;
    z-index: 1;
  }
  &-font {
    color: $font_color;
  }
  &:nth-child(1) {
    .step-line {
      width: 50%;
    }
  }
  &:nth-child(2) {
    width: 40%;
  }
  &:nth-child(3) {
    .step-line {
      width: 50%;
      left: 0;
    }
  }
  &.active {
    .step-bg {
      background: $link_color;
      color: $content_color;
    }
    .step-font {
      color: $link_color;
    }
    .step-line {
      background: $link_color;
    }
  }
}
.review-import {
  .iconfont {
    font-size: $font_size_p1;
  }
}
.padding-right {
  padding-right: 5px;
  border-right: 1px $line_color solid;
}
.success-bg {
  background: rgba($success_color, 0.2);
}
.key-bg {
  background: rgba($key_color, 0.2);
}
.warning-bg {
  background: rgba($warning_color, 0.2);
}
.padding {
  padding: 0 12px;
}
</style>
